import {
  IInitializeExternalSources,
  initializeExternalSources,
} from './DexeroFormExternalSources/initializeExternalSources';
import {
  ILoadExternalSources,
  loadExternalSources,
} from './DexeroFormExternalSources/loadExternalSources';
import {
  ISelectExternalSourceResult,
  selectExternalSourceResult,
} from './DexeroFormExternalSources/selectExternalSourceResult';
import {
  IShowExternalSourceSearchPopup,
  showExternalSourceSearchPopup,
} from './DexeroFormExternalSources/showExternalSourceSearchPopup';

export interface IDexeroFormExternalSources {
  initializeExternalSources: IInitializeExternalSources;
  loadExternalSources: ILoadExternalSources;
  selectExternalSourceResult: ISelectExternalSourceResult;
  showExternalSourceSearchPopup: IShowExternalSourceSearchPopup;
}

const DexeroFormExternalSources: IDexeroFormExternalSources = {
  initializeExternalSources,

  loadExternalSources,

  selectExternalSourceResult,

  showExternalSourceSearchPopup,
};

export default DexeroFormExternalSources;
